import { combineReducers } from "@reduxjs/toolkit";
import common from "./common.slice";
import master from "./master.slice";
import userAdmin from "./userAdmin.slice";
import customer from "./customer.slice";

const rootReducer = combineReducers({
  common: common,
  master: master,
  userAdmin: userAdmin,
  customer: customer,
});
export default rootReducer;
